import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pirating Hulu et al. is fighting racism!",
  "description": "",
  "published": "2009-11-24T00:00:00.000Z",
  "redirect_from": ["/blog/pirating-hulu-et-al-is-fighting-racism/swizec/893"],
  "categories": "food for thought, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Hulu is probably the staple of racist regional copyright restrictions in the world, but there are many others like Youtube in some cases, the iStore, BBC's video player thingy where they release all their tv shows and probably many others.`}</p>
    <p>{`Now, out of those, the only one I can understand is BBC because they are paid from a tax on the people and everybody outside the UK doesn't actually pay said tax and BBC is too lazy to figure out a different scheme for us.`}</p>
    <p>{`But onward to the issue.`}</p>
    <p>{`Have you ever seen any of these or something along these lines?`}</p>
    <p>{`If you have seen those it means `}<em parentName="p">{`someone`}</em>{` was being racist (actually ethnicist) towards you and you should fight for your rights! Seriously! Now I realise most of those say that they're only doing this due to some sort of contractual obligations and are working desperately towards making a customer out of you.`}</p>
    <p>{`But you know what, the only ones I've ever seen actually `}{`_`}{`do `}{`_`}{`something about it were SouthParkStudios - and that makes them supercool in my book. I don't pirate South Park anymore because of that.`}</p>
    <p>{`The main reason why these sort of `}<strong parentName="p">{`regional copyright practices are bloody racist`}</strong>{` is that:`}</p>
    <ol>
      <li parentName="ol">{`"Those other countries aren't worthy of paying for our content"`}</li>
      <li parentName="ol">{`"Oh those other people can watch shows `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Broadcast_syndication",
          "title": "Broadcast syndication"
        }}>{`syndicated`}</a>{` two years behind the curve when all the jokes are stale and all event references are long gone"`}</li>
      <li parentName="ol">{`"Our business model is so outdated we need to create `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Artificial_scarcity",
          "title": "Artificial scarcity"
        }}>{`artificial scarcity`}</a>{` to keep it up"`}</li>
    </ol>
    <p>{`And all of these racist presumptions they make are due simply to the fact the "majors" still haven't figured out that with the advent of the internets there is no notion of country for what is essentially information. `}<strong parentName="p">{`We're all citizens of the same world!`}</strong></p>
    <p>{`So I implore you dear reader, pirate, pirate and pirate some more everything and anything that they feel you are unworthy of being sold. And then pirate it some more!`}</p>
    <p>{`PS: please send this link onward if you agree, but especially if you don't.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/c49d63bf-a4ba-4684-a240-f2af67839c47/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=c49d63bf-a4ba-4684-a240-f2af67839c47",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      